// Chain metadata for CoreWallet
export const CHAINS = [
  { id: "btc", name: "Bitcoin", symbol: "BTC", decimals: 8, color: "#F7931A", price: "BTC", acct: "btc", family: "btc" },
  { id: "eth", name: "Ethereum", symbol: "ETH", decimals: 18, color: "#627EEA", price: "ETH", acct: "evm", family: "evm" },
  { id: "bsc", name: "BNB Smart Chain", symbol: "BNB", decimals: 18, color: "#F3BA2F", price: "BNB", acct: "evm", family: "evm" },
  { id: "polygon", name: "Polygon", symbol: "POL", decimals: 18, color: "#8247E5", price: "POL", acct: "evm", family: "evm" },
  { id: "sol", name: "Solana", symbol: "SOL", decimals: 9, color: "#14F195", price: "SOL", acct: "sol", family: "sol" },
  { id: "tron", name: "Tron", symbol: "TRX", decimals: 6, color: "#FF0013", price: "TRX", acct: "tron", family: "tron" },
];

export const getChain = (id) => CHAINS.find((c) => c.id === id);

export const addressFor = (accounts, chainId) => {
  if (!accounts) return "";
  const c = getChain(chainId);
  return accounts[c.acct]?.address || "";
};

export const shorten = (addr, n = 6) =>
  addr ? `${addr.slice(0, n)}…${addr.slice(-4)}` : "";

export const fmtNum = (v, max = 6) => {
  if (v === undefined || v === null || isNaN(v)) return "0";
  const num = Number(v);
  if (num === 0) return "0";
  if (num < 0.000001) return num.toExponential(2);
  return num.toLocaleString("en-US", { maximumFractionDigits: max });
};

export const fmtUsd = (v) => {
  const num = Number(v || 0);
  return num.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });
};
